import React, { useState, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Search, Bell, Download, Brain, TrendingUp, TrendingDown, DollarSign,
  ChevronLeft, ChevronRight, ArrowUpDown, ArrowUp, ArrowDown,
  BarChart3, PieChart, Activity, Users, Landmark, Heart,
  Building2, Target, Flag, Award
} from 'lucide-react';
import './PoliticalDonationsPage.css';

// =============================================================================
// MOCK DATA — FEC campaign contributions
// =============================================================================

const mockDonations = [
  { id: 1, donor: 'Alphabet Inc', ticker: 'GOOGL', donorType: 'Corporate PAC', recipient: 'Senate Leadership Fund', recipientType: 'Super PAC', party: 'R', amount: 5000000, sector: 'Technology', date: '2026-01-28', cycle: '2026', state: 'DC' },
  { id: 2, donor: 'Microsoft Corp', ticker: 'MSFT', donorType: 'Corporate PAC', recipient: 'Democratic Congressional Campaign', recipientType: 'Party Committee', party: 'D', amount: 3200000, sector: 'Technology', date: '2026-01-25', cycle: '2026', state: 'DC' },
  { id: 3, donor: 'JPMorgan Chase & Co', ticker: 'JPM', donorType: 'Corporate PAC', recipient: 'National Republican Senatorial Cmte', recipientType: 'Party Committee', party: 'R', amount: 4100000, sector: 'Financials', date: '2026-01-22', cycle: '2026', state: 'DC' },
  { id: 4, donor: 'Lockheed Martin', ticker: 'LMT', donorType: 'Corporate PAC', recipient: 'House Armed Services Members', recipientType: 'Leadership PAC', party: 'R', amount: 2800000, sector: 'Defense', date: '2026-01-20', cycle: '2026', state: 'VA' },
  { id: 5, donor: 'Goldman Sachs Group', ticker: 'GS', donorType: 'Corporate PAC', recipient: 'Democratic Senatorial Campaign', recipientType: 'Party Committee', party: 'D', amount: 3600000, sector: 'Financials', date: '2026-01-18', cycle: '2026', state: 'NY' },
  { id: 6, donor: 'Meta Platforms', ticker: 'META', donorType: 'Corporate PAC', recipient: 'Senate Leadership Fund', recipientType: 'Super PAC', party: 'R', amount: 4500000, sector: 'Technology', date: '2026-01-15', cycle: '2026', state: 'CA' },
  { id: 7, donor: 'Pfizer Inc', ticker: 'PFE', donorType: 'Corporate PAC', recipient: 'Senate Health Committee Members', recipientType: 'Leadership PAC', party: 'D', amount: 1900000, sector: 'Healthcare', date: '2026-01-12', cycle: '2026', state: 'NY' },
  { id: 8, donor: 'Exxon Mobil Corp', ticker: 'XOM', donorType: 'Corporate PAC', recipient: 'American Energy Alliance', recipientType: 'Super PAC', party: 'R', amount: 6200000, sector: 'Energy', date: '2026-01-10', cycle: '2026', state: 'TX' },
  { id: 9, donor: 'Amazon.com Inc', ticker: 'AMZN', donorType: 'Corporate PAC', recipient: 'Congressional Leadership Fund', recipientType: 'Super PAC', party: 'R', amount: 3800000, sector: 'Technology', date: '2026-01-08', cycle: '2026', state: 'WA' },
  { id: 10, donor: 'Comcast Corp', ticker: 'CMCSA', donorType: 'Corporate PAC', recipient: 'Democratic National Committee', recipientType: 'Party Committee', party: 'D', amount: 2400000, sector: 'Communication', date: '2026-01-05', cycle: '2026', state: 'PA' },
  { id: 11, donor: 'Boeing Co', ticker: 'BA', donorType: 'Corporate PAC', recipient: 'House Armed Services Members', recipientType: 'Leadership PAC', party: 'R', amount: 2200000, sector: 'Defense', date: '2026-01-03', cycle: '2026', state: 'IL' },
  { id: 12, donor: 'Raytheon Technologies', ticker: 'RTX', donorType: 'Corporate PAC', recipient: 'Senate Armed Services Members', recipientType: 'Leadership PAC', party: 'R', amount: 1800000, sector: 'Defense', date: '2025-12-28', cycle: '2026', state: 'MA' },
  { id: 13, donor: 'Chevron Corp', ticker: 'CVX', donorType: 'Corporate PAC', recipient: 'American Crossroads', recipientType: 'Super PAC', party: 'R', amount: 4800000, sector: 'Energy', date: '2025-12-22', cycle: '2026', state: 'CA' },
  { id: 14, donor: 'Apple Inc', ticker: 'AAPL', donorType: 'Corporate PAC', recipient: 'Democratic Congressional Campaign', recipientType: 'Party Committee', party: 'D', amount: 2900000, sector: 'Technology', date: '2025-12-20', cycle: '2026', state: 'CA' },
  { id: 15, donor: 'UnitedHealth Group', ticker: 'UNH', donorType: 'Corporate PAC', recipient: 'Senate Finance Committee Members', recipientType: 'Leadership PAC', party: 'R', amount: 3400000, sector: 'Healthcare', date: '2025-12-18', cycle: '2026', state: 'MN' },
  { id: 16, donor: 'Citigroup Inc', ticker: 'C', donorType: 'Corporate PAC', recipient: 'New Democrat Coalition', recipientType: 'Leadership PAC', party: 'D', amount: 1600000, sector: 'Financials', date: '2025-12-15', cycle: '2026', state: 'NY' },
  { id: 17, donor: 'Northrop Grumman', ticker: 'NOC', donorType: 'Corporate PAC', recipient: 'Congressional Leadership Fund', recipientType: 'Super PAC', party: 'R', amount: 2100000, sector: 'Defense', date: '2025-12-12', cycle: '2026', state: 'VA' },
  { id: 18, donor: 'NVIDIA Corp', ticker: 'NVDA', donorType: 'Corporate PAC', recipient: 'Senate Leadership Fund', recipientType: 'Super PAC', party: 'R', amount: 3100000, sector: 'Technology', date: '2025-12-10', cycle: '2026', state: 'CA' },
  { id: 19, donor: 'AT&T Inc', ticker: 'T', donorType: 'Corporate PAC', recipient: 'Republican National Committee', recipientType: 'Party Committee', party: 'R', amount: 2600000, sector: 'Communication', date: '2025-12-08', cycle: '2026', state: 'TX' },
  { id: 20, donor: 'Johnson & Johnson', ticker: 'JNJ', donorType: 'Corporate PAC', recipient: 'Senate Health Committee Members', recipientType: 'Leadership PAC', party: 'D', amount: 1400000, sector: 'Healthcare', date: '2025-12-05', cycle: '2026', state: 'NJ' },
];

const mockTopDonors = [
  { donor: 'Exxon Mobil', total: 6200000, party: 'R', sector: 'Energy' },
  { donor: 'Alphabet Inc', total: 5000000, party: 'R', sector: 'Technology' },
  { donor: 'Chevron Corp', total: 4800000, party: 'R', sector: 'Energy' },
  { donor: 'Meta Platforms', total: 4500000, party: 'R', sector: 'Technology' },
  { donor: 'JPMorgan Chase', total: 4100000, party: 'R', sector: 'Financials' },
];

const mockTopRecipients = [
  { recipient: 'Senate Leadership Fund', total: 12600000, party: 'R', type: 'Super PAC' },
  { recipient: 'Congressional Leadership Fund', total: 5900000, party: 'R', type: 'Super PAC' },
  { recipient: 'Democratic Congressional Campaign', total: 6100000, party: 'D', type: 'Party Committee' },
  { recipient: 'American Crossroads', total: 4800000, party: 'R', type: 'Super PAC' },
  { recipient: 'Democratic Senatorial Campaign', total: 3600000, party: 'D', type: 'Party Committee' },
];

const mockSectorDonations = [
  { sector: 'Technology', total: 22500000, pct: 31.4, r: 16400000, d: 6100000 },
  { sector: 'Energy', total: 11000000, pct: 15.3, r: 11000000, d: 0 },
  { sector: 'Financials', total: 9300000, pct: 13.0, r: 4100000, d: 5200000 },
  { sector: 'Defense', total: 8900000, pct: 12.4, r: 8900000, d: 0 },
  { sector: 'Healthcare', total: 6700000, pct: 9.3, r: 3400000, d: 3300000 },
  { sector: 'Communication', total: 5000000, pct: 7.0, r: 2600000, d: 2400000 },
];

// =============================================================================
// HELPERS
// =============================================================================

const formatCurrency = (num) => {
  if (!num && num !== 0) return '—';
  if (Math.abs(num) >= 1e9) return `$${(num / 1e9).toFixed(1)}B`;
  if (Math.abs(num) >= 1e6) return `$${(num / 1e6).toFixed(1)}M`;
  if (Math.abs(num) >= 1e3) return `$${(num / 1e3).toFixed(0)}K`;
  return `$${num.toFixed(0)}`;
};

// =============================================================================
// SUB-COMPONENTS
// =============================================================================

function AIInsightCard({ insight }) {
  return (
    <div className="pd-ai-insight">
      <div className="pd-ai-header">
        <div className="pd-ai-badge"><Brain size={14} /> AI Insight</div>
        <span className="pd-ai-updated">Updated 6 hours ago</span>
      </div>
      <p className="pd-ai-text" dangerouslySetInnerHTML={{ __html: insight }} />
    </div>
  );
}

function StatCard({ icon: Icon, label, value, sub, subType = 'neutral', color }) {
  return (
    <div className="pd-stat-card" style={{ background: color }}>
      <div className="pd-stat-icon"><Icon size={20} /></div>
      <div className="pd-stat-label">{label}</div>
      <div className="pd-stat-value">{value}</div>
      <div className={`pd-stat-sub ${subType}`}>{sub}</div>
    </div>
  );
}

// =============================================================================
// MAIN COMPONENT
// =============================================================================

export default function PoliticalDonationsPage() {
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState('');
  const [partyFilter, setPartyFilter] = useState('All');
  const [sectorFilter, setSectorFilter] = useState('All');
  const [sortBy, setSortBy] = useState('date');
  const [sortOrder, setSortOrder] = useState('desc');
  const [currentPage, setCurrentPage] = useState(1);
  const perPage = 20;

  const partyFilters = ['All', 'Republican', 'Democrat'];
  const sectorFilters = ['All', 'Technology', 'Financials', 'Energy', 'Defense', 'Healthcare'];

  const filteredDonations = useMemo(() => {
    let data = [...mockDonations];
    if (searchTerm) {
      const q = searchTerm.toLowerCase();
      data = data.filter(d => d.donor.toLowerCase().includes(q) || d.recipient.toLowerCase().includes(q) || d.sector.toLowerCase().includes(q));
    }
    if (partyFilter !== 'All') {
      const p = partyFilter === 'Republican' ? 'R' : 'D';
      data = data.filter(d => d.party === p);
    }
    if (sectorFilter !== 'All') data = data.filter(d => d.sector === sectorFilter);

    data.sort((a, b) => {
      const order = sortOrder === 'asc' ? 1 : -1;
      if (sortBy === 'donor') return order * a.donor.localeCompare(b.donor);
      if (sortBy === 'recipient') return order * a.recipient.localeCompare(b.recipient);
      if (sortBy === 'amount') return order * (a.amount - b.amount);
      if (sortBy === 'date') return order * a.date.localeCompare(b.date);
      return 0;
    });
    return data;
  }, [searchTerm, partyFilter, sectorFilter, sortBy, sortOrder]);

  const totalPages = Math.ceil(filteredDonations.length / perPage);
  const pagedDonations = filteredDonations.slice((currentPage - 1) * perPage, currentPage * perPage);

  const handleSort = (field) => {
    if (sortBy === field) setSortOrder(o => o === 'asc' ? 'desc' : 'asc');
    else { setSortBy(field); setSortOrder('desc'); }
  };

  const SortIcon = ({ field }) => {
    if (sortBy !== field) return <ArrowUpDown size={12} style={{ opacity: 0.3 }} />;
    return sortOrder === 'asc' ? <ArrowUp size={12} /> : <ArrowDown size={12} />;
  };

  const stats = useMemo(() => {
    const totalAmount = mockDonations.reduce((s, d) => s + d.amount, 0);
    const repTotal = mockDonations.filter(d => d.party === 'R').reduce((s, d) => s + d.amount, 0);
    const demTotal = mockDonations.filter(d => d.party === 'D').reduce((s, d) => s + d.amount, 0);
    const donors = new Set(mockDonations.map(d => d.donor)).size;
    return { totalAmount, repTotal, demTotal, donors };
  }, []);

  const repPct = ((stats.repTotal / stats.totalAmount) * 100).toFixed(0);
  const demPct = ((stats.demTotal / stats.totalAmount) * 100).toFixed(0);

  const aiInsight = `<span class="highlight">Corporate PAC spending surged 34% QoQ</span> heading into the 2026 midterm cycle. <span class="highlight">Energy</span> and <span class="highlight">Defense</span> sectors are donating almost exclusively to Republican committees, while <span class="highlight">Technology</span> is splitting 73/27 R/D — a shift from the 60/40 D/R split in 2024. <span class="highlight">Exxon Mobil</span> leads all corporate donors at $6.2M, followed by <span class="highlight">Alphabet</span> at $5M. Senate Leadership Fund is the top recipient at $12.6M.`;

  return (
    <div className="political-donations-page">
      {/* Header */}
      <div className="pd-page-header">
        <div className="pd-header-content">
          <div className="pd-header-title">
            <div className="pd-header-icon"><Heart size={22} color="#fff" /></div>
            <div>
              <h1>Political Donations</h1>
              <p>Corporate PAC contributions, campaign fundraising, and political spending (FEC data)</p>
            </div>
          </div>
          <div className="pd-header-actions">
            <button className="pd-header-btn"><Download size={14} /> Export</button>
            <button className="pd-header-btn primary"><Bell size={14} /> Set Alerts</button>
          </div>
        </div>
      </div>

      {/* AI Insight */}
      <AIInsightCard insight={aiInsight} />

      {/* Stats Row */}
      <div className="pd-stats-row">
        <StatCard icon={DollarSign} label="Total Contributions" value={formatCurrency(stats.totalAmount)} sub={`${stats.donors} corporate donors`} subType="neutral" color="linear-gradient(135deg, rgba(102, 126, 234, 0.2), rgba(118, 75, 162, 0.2))" />
        <StatCard icon={Flag} label="Republican" value={formatCurrency(stats.repTotal)} sub={`${repPct}% of total`} subType="neutral" color="linear-gradient(135deg, rgba(239, 68, 68, 0.2), rgba(220, 38, 38, 0.2))" />
        <StatCard icon={Flag} label="Democrat" value={formatCurrency(stats.demTotal)} sub={`${demPct}% of total`} subType="neutral" color="linear-gradient(135deg, rgba(59, 130, 246, 0.2), rgba(37, 99, 235, 0.2))" />
        <StatCard icon={Landmark} label="2026 Cycle" value="Midterms" sub="All 435 House + 33 Senate seats" subType="neutral" color="linear-gradient(135deg, rgba(245, 158, 11, 0.2), rgba(217, 119, 6, 0.2))" />
      </div>

      {/* Content Grid */}
      <div className="pd-content-grid">
        {/* Main Table */}
        <div className="pd-table-panel">
          <div className="pd-panel-header">
            <h2><DollarSign size={16} /> Campaign Contributions <span className="pd-record-count">{filteredDonations.length}</span></h2>
          </div>

          {/* Toolbar */}
          <div className="pd-toolbar">
            <div className="pd-search-box">
              <Search size={14} />
              <input type="text" placeholder="Search donor, recipient, or sector..." value={searchTerm} onChange={(e) => { setSearchTerm(e.target.value); setCurrentPage(1); }} />
            </div>
            <div className="pd-filter-group">
              <div className="pd-filter-toggles">
                {partyFilters.map(f => (
                  <button key={f} className={`pd-filter-btn ${f === 'Republican' ? 'rep' : f === 'Democrat' ? 'dem' : ''} ${partyFilter === f ? 'active' : ''}`} onClick={() => { setPartyFilter(f); setCurrentPage(1); }}>{f}</button>
                ))}
              </div>
              <div className="pd-filter-toggles secondary">
                {sectorFilters.map(f => (
                  <button key={f} className={`pd-filter-btn ${sectorFilter === f ? 'active' : ''}`} onClick={() => { setSectorFilter(f); setCurrentPage(1); }}>{f}</button>
                ))}
              </div>
            </div>
          </div>

          {/* Table */}
          {filteredDonations.length === 0 ? (
            <div className="pd-empty-state"><Search size={40} /><p>No donations match your filters</p></div>
          ) : (
            <div className="pd-table-wrap">
              <table className="pd-table">
                <thead>
                  <tr>
                    <th onClick={() => handleSort('donor')}>Donor <SortIcon field="donor" /></th>
                    <th>Sector</th>
                    <th onClick={() => handleSort('recipient')}>Recipient <SortIcon field="recipient" /></th>
                    <th>Party</th>
                    <th onClick={() => handleSort('amount')}>Amount <SortIcon field="amount" /></th>
                    <th>Type</th>
                    <th onClick={() => handleSort('date')}>Date <SortIcon field="date" /></th>
                  </tr>
                </thead>
                <tbody>
                  {pagedDonations.map(d => (
                    <tr key={d.id} onClick={() => navigate(`/stock/${d.ticker}`)} style={{ cursor: 'pointer' }}>
                      <td>
                        <span className="pd-donor-name">{d.donor}</span>
                        <span className="pd-donor-type">{d.donorType}</span>
                      </td>
                      <td><span className="pd-sector-badge">{d.sector}</span></td>
                      <td>
                        <span className="pd-recipient-name">{d.recipient}</span>
                      </td>
                      <td>
                        <span className={`pd-party-badge ${d.party === 'R' ? 'republican' : 'democrat'}`}>
                          {d.party === 'R' ? 'R' : 'D'}
                        </span>
                      </td>
                      <td><span className="pd-amount">{formatCurrency(d.amount)}</span></td>
                      <td><span className="pd-type">{d.recipientType}</span></td>
                      <td>{new Date(d.date).toLocaleDateString('en-US', { month: 'short', day: 'numeric' })}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}

          {/* Pagination */}
          {totalPages > 1 && (
            <div className="pd-pagination">
              <span className="pd-pagination-info">Showing {pagedDonations.length} of {filteredDonations.length} contributions</span>
              <div className="pd-pagination-btns">
                <button className="pd-page-btn" onClick={() => setCurrentPage(p => Math.max(1, p - 1))} disabled={currentPage === 1}><ChevronLeft size={14} /></button>
                {Array.from({ length: totalPages }, (_, i) => (
                  <button key={i + 1} className={`pd-page-btn ${currentPage === i + 1 ? 'active' : ''}`} onClick={() => setCurrentPage(i + 1)}>{i + 1}</button>
                ))}
                <button className="pd-page-btn" onClick={() => setCurrentPage(p => Math.min(totalPages, p + 1))} disabled={currentPage === totalPages}><ChevronRight size={14} /></button>
              </div>
            </div>
          )}
        </div>

        {/* Sidebar */}
        <div className="pd-sidebar">
          {/* Party Split */}
          <div className="pd-sidebar-card">
            <div className="pd-card-header">
              <h3><PieChart size={16} color="#667eea" /> Party Split</h3>
            </div>
            <div className="pd-party-split">
              <div className="pd-split-bar">
                <div className="pd-split-r" style={{ width: `${repPct}%` }} />
                <div className="pd-split-d" style={{ width: `${demPct}%` }} />
              </div>
              <div className="pd-split-legend">
                <div className="pd-split-item">
                  <span className="pd-dot republican" />
                  <span className="pd-split-label">Republican</span>
                  <span className="pd-split-value">{formatCurrency(stats.repTotal)} ({repPct}%)</span>
                </div>
                <div className="pd-split-item">
                  <span className="pd-dot democrat" />
                  <span className="pd-split-label">Democrat</span>
                  <span className="pd-split-value">{formatCurrency(stats.demTotal)} ({demPct}%)</span>
                </div>
              </div>
            </div>
          </div>

          {/* Top Donors */}
          <div className="pd-sidebar-card">
            <div className="pd-card-header">
              <h3><Building2 size={16} color="#f59e0b" /> Top Donors</h3>
            </div>
            <div className="pd-rank-list">
              {mockTopDonors.map((d, i) => (
                <div className="pd-rank-item" key={i}>
                  <span className={`pd-rank ${i === 0 ? 'gold' : i === 1 ? 'silver' : i === 2 ? 'bronze' : ''}`}>{i + 1}</span>
                  <div className="pd-rank-info">
                    <span className="pd-rank-name">{d.donor}</span>
                    <span className="pd-rank-meta">{d.sector}</span>
                  </div>
                  <div className="pd-rank-data">
                    <span className="pd-rank-amount">{formatCurrency(d.total)}</span>
                    <span className={`pd-rank-party ${d.party === 'R' ? 'republican' : 'democrat'}`}>{d.party === 'R' ? 'R' : 'D'}</span>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Top Recipients */}
          <div className="pd-sidebar-card">
            <div className="pd-card-header">
              <h3><Landmark size={16} color="#10b981" /> Top Recipients</h3>
            </div>
            <div className="pd-rank-list">
              {mockTopRecipients.map((r, i) => (
                <div className="pd-rank-item" key={i}>
                  <span className={`pd-rank ${i === 0 ? 'gold' : i === 1 ? 'silver' : i === 2 ? 'bronze' : ''}`}>{i + 1}</span>
                  <div className="pd-rank-info">
                    <span className="pd-rank-name">{r.recipient}</span>
                    <span className="pd-rank-meta">{r.type}</span>
                  </div>
                  <div className="pd-rank-data">
                    <span className="pd-rank-amount">{formatCurrency(r.total)}</span>
                    <span className={`pd-rank-party ${r.party === 'R' ? 'republican' : 'democrat'}`}>{r.party === 'R' ? 'R' : 'D'}</span>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Sector Breakdown */}
          <div className="pd-sidebar-card">
            <div className="pd-card-header">
              <h3><BarChart3 size={16} color="#a78bfa" /> Donations by Sector</h3>
            </div>
            <div className="pd-sector-list">
              {mockSectorDonations.map((s, i) => (
                <div className="pd-sector-row" key={i}>
                  <div className="pd-sector-info">
                    <span className="pd-sector-name">{s.sector}</span>
                    <span className="pd-sector-total">{formatCurrency(s.total)}</span>
                  </div>
                  <div className="pd-sector-bar-wrap">
                    <div className="pd-sector-bar-r" style={{ width: `${(s.r / s.total) * (s.pct / mockSectorDonations[0].pct) * 100}%` }} />
                    <div className="pd-sector-bar-d" style={{ width: `${(s.d / s.total) * (s.pct / mockSectorDonations[0].pct) * 100}%` }} />
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}